// src/Login.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Button from "@mui/material/Button";
import "./login.css";

const Login = () => {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const navigate = useNavigate();

	const handleClickShowPassword = () => setShowPassword((show) => !show);

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	const handleMouseUpPassword = (event) => {
		event.preventDefault();
	};

	const handleLogin = async () => {
		try {
			await signInWithEmailAndPassword(auth, email, password);
			navigate("/"); // Перенаправляем на главную страницу
			console.log("click");
		} catch (err) {
			setError("Ошибка входа: " + err.message);
		}
	};

	return (
		<div className="login">
			<div className="login-wrapper">
				<div className="login-logo">
					<img src="/icons/logo-login.svg" alt="logo" />
				</div>
				<div className="login-form-wrapper">
					<div className="login-form">
						<div className="login-form-title">
							<div className="registration-content-header-item">
								<h3>Добро пожаловать в Cscalp</h3>
								<h2>Войти</h2>
							</div>
							<div className="registration-content-header-item">
								<p className="registration-content-header-subtitle">
									Еще нет аккаунта?
								</p>
								<Button variant="outlined" onClick={() => navigate("/registration")}>
									Зарегистрироваться
								</Button>
							</div>
						</div>
						<div className="login-form-main">
							<form className="login-form-main-item">
								<label htmlFor="email">Введите адрес электронной почты *</label>
								<TextField
									id="email"
									type="email"
									name="email"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									variant="outlined"
									size="small"
									autoComplete="new-email"
									sx={{
										width: 360,
										border: "1px solid #6f6f80",
										borderRadius: "5px",
										"& .MuiInputBase-input": {
											color: "#3d404f",
										},
									}}
								/>
							</form>
							<div className="login-form-main-item">
								<label htmlFor="password">Введите пароль *</label>
								<FormControl
									sx={{
										width: 360,
										border: "1px solid #6f6f80",
										borderRadius: "5px",
										"& .MuiInputBase-input": {
											color: "#3d404f",
										},
										"& .MuiIconButton-root": {
											color: "#6f6f80",
										},
									}}
									size="small"
									variant="outlined"
								>
									<OutlinedInput
										id="password"
										type={showPassword ? "text" : "password"}
										endAdornment={
											<InputAdornment position="end">
												<IconButton
													aria-label={
														showPassword ? "hide the password" : "display the password"
													}
													onClick={handleClickShowPassword}
													onMouseDown={handleMouseDownPassword}
													onMouseUp={handleMouseUpPassword}
													edge="end"
												>
													{showPassword ? (
														<FontAwesomeIcon icon={faEye} />
													) : (
														<FontAwesomeIcon icon={faEyeSlash} />
													)}
												</IconButton>
											</InputAdornment>
										}
										value={password}
										onChange={(e) => setPassword(e.target.value)}
									/>
								</FormControl>
							</div>
							<Button
								variant="contained"
								onClick={handleLogin}
								color="success"
								sx={{
									width: 260,
									mt: 3,
									backgroundColor: "#28a745",
									"&:hover": {
										backgroundColor: "#218838",
									},
									"&:disabled": {
										backgroundColor: "#c3e6cb",
										color: "#6c757d",
									},
								}}
								disabled={!email || !password}
							>
								Войти
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Login;
